export default {
  bind(el, binding) {
    const handler = binding.value

    el.__escapeHandler__ = function (event) {
      if (event.keyCode === 27) {
        handler(event)
      }
    }

    document.addEventListener('keyup', el.__escapeHandler__)
  },

  unbind(el, binding) {
    if (!el.__escapeHandler__) {
      return
    }

    document.removeEventListener('keyup', el.__escapeHandler__)
    el.__escapeHandler__ = null
  }
}
